import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { signInWithEmailAndPassword, onAuthStateChanged } from 'firebase/auth';
import { doc, getDoc, setDoc } from 'firebase/firestore';
import { auth, db } from '../../firebase';
import PosterHeader from '../../components/header/PosterHeaderBar/PosterHeader';
import Footer from '../../components/footer/footer';
import './BlogAdminPage.css';

function BlogAdminPage() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    // Check if user is already logged in
    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, async (user) => {
            if (user) {
                // Check if the user is an admin
                const userDoc = await getDoc(doc(db, 'users', user.uid));
                if (userDoc.exists() && userDoc.data().isAdmin) {
                    // Already logged in as admin, redirect to blog
                    navigate('/blog');
                }
            }
        });

        return () => unsubscribe();
    }, [navigate]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);

        try {
            // Sign in with email and password
            const userCredential = await signInWithEmailAndPassword(auth, email, password);
            const user = userCredential.user;

            // Check if user document exists in Firestore
            const userDoc = await getDoc(doc(db, 'users', user.uid));

            // If user document doesn't exist, create it and set admin privileges
            if (!userDoc.exists()) {
                await setDoc(doc(db, 'users', user.uid), {
                    email: user.email,
                    isAdmin: true, // Give admin privileges
                    createdAt: new Date()
                });
            } else if (!userDoc.data().isAdmin) {
                // If user exists but isn't admin, update to make them admin
                await setDoc(doc(db, 'users', user.uid), {
                    ...userDoc.data(),
                    isAdmin: true
                }, { merge: true });
            }

            // Redirect to blog page after successful login
            navigate('/blog');
        } catch (error) {
            console.error('Error signing in:', error);
            setError('Invalid email or password. Please try again.');
        }

        setLoading(false);
    };

    const handleBack = () => {
        navigate('/blog');
    };

    return (
        <div className="admin-page">
            <PosterHeader />

            <div className="admin-container">
                <button onClick={handleBack} className="back-button">
                    ← Back to blog
                </button>

                <div className="admin-login-form">
                    <h1 className="admin-title">Admin Login</h1>

                    <form onSubmit={handleSubmit}>
                        {error && <div className="error-message">{error}</div>}

                        <div className="form-group">
                            <label htmlFor="email">Email</label>
                            <input
                                type="email"
                                id="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="password">Password</label>
                            <input
                                type="password"
                                id="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                            />
                        </div>

                        <button
                            type="submit"
                            className="login-button"
                            disabled={loading}
                        >
                            {loading ? 'Signing in...' : 'Sign In'}
                        </button>
                    </form>
                </div>
            </div>

            <Footer />
        </div>
    );
}

export default BlogAdminPage; 